import { fromJS } from 'immutable';

import {
	Search,
	SearchAction,
	SearchActionTypes as actionTypes
} from './searchTypes';

const initialState = fromJS({
	data: [],
	failure: '',
	isLoading: false,
	searchIsSaving: false, // Updated: To track when the save is in progress
	isSaveSuccess: false, // To track if the save was successful
	saveError: null // To track any save error
});

export default (state = initialState, action: SearchAction) => {
	switch (action.type) {
		case actionTypes.SEARCH_ADD_SEARCH_REQUEST:
			return state
				.set('searchIsSaving', true)
				.set('isSaveSuccess', false)
				.set('saveError', null);

		case actionTypes.SEARCH_ADD_SEARCH_SUCCESS: {
			const { data } = action.payload;
			const searches: any[] = state.get('data').toJS();

			if (!data || data.message) {
				return state
					.set('searchIsSaving', false)
					.set('isSaveSuccess', false)
					.set('saveError', 'Payload is missing');
			}

			searches.push(data);

			return state
				.set('data', fromJS(searches))
				.set('searchIsSaving', false)
				.set('isSaveSuccess', true)
				.set('saveError', null);
		}

		case actionTypes.SEARCH_ADD_SEARCH_RESET: {
			return state
				.set('searchIsSaving', false)
				.set('isSaveSuccess', false)
				.set('saveError', null);
		}

		case actionTypes.SEARCH_ADD_SEARCH_FAILURE:
			return state
				.set('searchIsSaving', false)
				.set('isSaveSuccess', false)
				.set('saveError', action.error);

		case actionTypes.SEARCH_GET_SEARCHES_SUCCESS: {
			const { data } = action.payload;

			return state.set('data', fromJS(data));
		}

		case actionTypes.SEARCH_REMOVE_SEARCH_SUCCESS:
			return state.set(
				'data',
				fromJS(
					state
						.get('data')
						.toJS()
						.filter(
							(search: Search) => search.id !== action.payload.id
						)
				)
			);

		case actionTypes.SEARCH_RESET_SAVE_STATUS: // Reset the saving states
			return state
				.set('searchIsSaving', false)
				.set('isSaveSuccess', false)
				.set('saveError', null);

		case actionTypes.SEARCH_EDIT_SEARCH_REQUEST:
			return state
				.set('searchIsSaving', true)
				.set('isSaveSuccess', false)
				.set('saveError', null);

		case actionTypes.SEARCH_EDIT_SEARCH_SUCCESS: {
			const { data } = action.payload;
			const searches = state
				.get('data')
				.toJS()
				.map((search: Search) =>
					search.id === data.id ? data : search
				);

			return state
				.set('data', fromJS(searches))
				.set('searchIsSaving', false)
				.set('isSaveSuccess', true)
				.set('saveError', null);
		}

		case actionTypes.SEARCH_EDIT_SEARCH_FAILURE:
			return state
				.set('searchIsSaving', false)
				.set('isSaveSuccess', false)
				.set('saveError', action.error);

		case actionTypes.SEARCH_GET_SEARCHES_REQUEST:
		case actionTypes.SEARCH_GET_SEARCHES_FAILURE:
		case actionTypes.SEARCH_REMOVE_SEARCH_REQUEST:
		case actionTypes.SEARCH_REMOVE_SEARCH_FAILURE:
		default:
			return state;
	}
};
